export default __webpack_public_path__ + "static/media/instructions-snowball.81be248f.png";